// 使用RTK创建store, createSlice 创建reducer的切片
import { createSlice } from "@reduxjs/toolkit";
const counterSlice = createSlice({
  // 需要一个配置对象作为参数，通过对象的不同属性来指定它的配置
  name: "counter", // 用来自动生成 action 中的 type
  initialState: {
    // state的初始值
    isTabsShow: true,
  },
  // 指定state的各种操作，直接在对象中添加方法
  reducers: {
    inscrement: (state) => {
      // state是一个代理对象，可直接修改
      state.isTabsShow = !state.isTabsShow;
    },
    decrement: (state) => {
      state.isTabsShow = false;
    },
  },
});
// 切片对象会自动的帮助我们生成action
export const { inscrement, decrement } = counterSlice.actions;
// 导出 reducer
export default counterSlice.reducer;
